import { render } from "./index.vue?vue&type=template&id=fbe9a41e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=fbe9a41e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbe9a41e"],['__file',"src/components/ResetPasswordForm/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fbe9a41e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fbe9a41e', __exports__)) {
    api.reload('fbe9a41e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=fbe9a41e&scoped=true", () => {
    api.rerender('fbe9a41e', render)
  })

}


export default __exports__